import ClientModule from "@gqlapp/module-client-react";
import ViewRoute from "@modules/photo/containers/view";
import ListRoute from "@modules/photo/containers/list";
export default new ClientModule(ViewRoute, ListRoute);
